module.exports = __webpack_public_path__ + "static/media/conver_wasp.cedefc44.svg";